import { Box, Flex } from '@radix-ui/themes';
import { useCallback, useMemo } from 'react';
import {
    AdvancedVideoEngineProps,
    AdvancedVideoPlayerProps,
    UnifiedPlayerController,
} from '../types';
import { LimecraftEngine } from './LimecraftEngine';
import { VideoJsEngine } from './VideoJsEngine';

import { useControllerState, useMedia } from '../hooks';
import styles from './AdvancedVideoPlayer.module.css';
import { LoadingLayer } from './controls';

export const AdvancedVideoPlayer = ({ engine }: AdvancedVideoPlayerProps) => {
    const { controller: _, setController } = useControllerState();
    const { src, media, tracks, isLoading } = useMedia();

    const onReady = useCallback(
        (newController: UnifiedPlayerController) => {
            setController(newController);
        },
        [setController],
    );

    const engineArgs: AdvancedVideoEngineProps = useMemo(
        () => ({
            src,
            media,
            tracks,
            onReady,
        }),
        [media, onReady, src, tracks],
    );

    if (!src && !isLoading) return null;

    const renderEngine = () => {
        switch (engine) {
            case 'limecraft':
                return <LimecraftEngine {...engineArgs} />;

            case 'videojs':
                return <VideoJsEngine {...engineArgs} />;

            default:
                return null;
        }
    };

    return (
        <Flex
            direction='column'
            className={styles.playerContainer}
            align={'center'}
        >
            <LoadingLayer isLoading={isLoading}>
                <Box className={styles.playerBox}>{renderEngine()}</Box>
            </LoadingLayer>
        </Flex>
    );
};
